import Uint16ArrayUtils from '../collections/Uint16ArrayUtils';
export default class StringBuilder {
    constructor(expectedLength) {
        this.$startIndex = 0;
        this.$usedLength = 0;
        if (expectedLength !== undefined) {
            this.data = new Uint16Array(expectedLength);
        }
        else {
            this.data = new Uint16Array();
        }
    }
    get length() {
        return this.$usedLength;
    }
    append(text) {
        const remainingLength = this.data.length - this.$usedLength;
        if (remainingLength < text.length) {
            const newData = new Uint16Array((this.$usedLength + text.length) * 2);
            newData.set(this.data.subarray(this.$startIndex));
            this.$startIndex = 0;
            this.data = newData;
        }
        for (let dataIndex = this.$startIndex + this.$usedLength, textIndex = 0; textIndex < text.length; dataIndex++, textIndex++) {
            this.data[dataIndex] = text.charCodeAt(textIndex);
        }
        this.$usedLength = this.$usedLength + text.length;
        return this;
    }
    clear() {
        this.data = new Uint16Array();
        this.$usedLength = 0;
        return this;
    }
    remove(startIndex, length) {
        const maxRemovableLength = this.$usedLength - startIndex;
        length = Math.min(length !== null && length !== void 0 ? length : maxRemovableLength, maxRemovableLength);
        if (startIndex < 0) {
            throw new RangeError('Start index cannot be negative.');
        }
        else if (length < 0) {
            throw new RangeError('Length cannot be negative.');
        }
        else if (startIndex >= this.$usedLength) {
            return this;
        }
        else if (startIndex === this.$startIndex) {
            this.data.fill(0, this.$startIndex, this.$startIndex + length);
            this.$startIndex += length;
            this.$usedLength -= length;
        }
        else if (startIndex + length === this.$usedLength) {
            this.data.fill(0, this.$startIndex + startIndex, this.$startIndex + startIndex + length);
            this.$usedLength -= length;
        }
        else {
            const before = this.data.subarray(this.$startIndex, this.$startIndex + startIndex);
            const after = this.data.subarray(this.$startIndex + startIndex + length);
            this.data = Uint16ArrayUtils.concat(before, after);
            this.$startIndex = 0;
            this.$usedLength -= length;
        }
        return this;
    }
    toString() {
        return String.fromCharCode(...this.data.subarray(this.$startIndex, this.$startIndex + this.$usedLength));
    }
}
//# sourceMappingURL=StringBuilder.js.map